<template>
  <div class="trainlist">
    <el-row :gutter="20" v-if="totalCount" v-loading="loading">
      <el-col
        :xs="12"
        :sm="8"
        :md="8"
        :lg="6"
        v-for="(item,index) in data"
        :key="index"
        style="margin-top: 10px;"
      >
        <el-card shadow="always">
          <div class="testIndex-content">
            <router-link :to="{path:'/testInstitutions/testInstitutionsDetail',query:{id:item.id}}">
              <el-image
                style="width: 100%; height: 150px"
                :src="getImgUrl(item.institutional_view)"
              ></el-image>
              <p  style="text-align: center;height:22px;margin-top: 8px;">
                <el-image
                  v-for="(item,index) in item.star" :key="index"
                  style="width:18px ; height: 18px;margin-left: 5px"
                  src="/image/evaluationStaff/star.png"
                ></el-image>
              </p>
              <p class="name">{{item.mechanism_fullName}}</p>
            </router-link>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <no-data v-else />
    <div class="pagination" style="margin-top: 55px;text-align: center;">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="paging.limit"
        :total="totalCount"
        v-if="totalCount>20"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { GetTestMechList } from "@/api/admin/common.js";
import noData from "@/views/admin/components/noData.vue";
export default {
  components: {
    noData
  },
  data() {
    return {
      data: [],
      totalCount: 0,
      paging: {
        limit: 20,
        page: 1
      },
      loading: false,
      imgPath: window.apiObj.apiUrl
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    this.searchBus.$on("SearchData3", msg => {
      this.searchALLdata(msg);
    });
  },
  methods: {
    //图片路径拼接
    getImgUrl(file_path) {
      var url =  "";
      if(file_path == null){
        
        url = "/image/evaluationStaff/aaa.png";
        
      }else{
        url = this.imgPath + file_path;
      }
      return url;
    },
    getList() {
      // 测试机构列表
      GetTestMechList(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
          this.totalCount = list.totalCount;
        }
      });
    },
    // 测试机构列表分页
    handleCurrentChange(cpage) {
      this.paging.page = cpage;
      this.loading = true;
      GetTestMechList(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
          this.loading = false;
        }
      });
    },
    // 测试机构列表搜索
    searchALLdata(msg) {
      GetTestMechList(Object.assign(this.paging, msg)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
          this.totalCount = list.totalCount;
        }
      });
    }
  },
  beforeDestroy() {
    this.searchBus.$off("SearchData3");
  }
};
</script>

<style lang="less" scoped>
.trainlist {
  .el-card__body {
    padding: 0;
    .con {
      width: 80%;
      margin: auto;
      border-bottom: 1px solid #c4c4c4;
      color: #4e4e4e;
      text-align: center;
      padding: 9px 0;
      .badge {
        width: 25px;
        height: 25px;
        margin-right: 3px;
      }
    }
    .name{
      text-align: center;
      padding: 8px 0 0 0;
      color: #000000;
      font-size: 14px;
      height:51px
    }
  }
}
</style>
